// src/components/ItemList.js
import React from 'react';
import Box from '@mui/material/Box';
import RenderVehicle from './renderVehicle';

const ItemList = ({ itemName,items }) => {
  return (
    <div style={{marginTop:"10px", position:'relative', display:'block' }}>
    <h1 style={{textAlign:'center'}}>{itemName}</h1>
    <Box
      sx={{
        flexWrap: 'wrap',
        margin: 'auto',
        display: 'flex',
        marginBottom:'40px',
        justifyContent: 'center',   // Center horizontally
        alignItems: 'center',
        height:''
      }}
    >

      {items.map((item) => (
        <Box
          key={item.id}
          sx={{
            width: { xs: '100%', sm: '50%', md: '33.33%' }, // Responsive widths
            padding: '10px', // Adjust padding as needed
            boxSizing: 'border-box',
            display:'flex',
            justifyContent: 'center',   // Center horizontally
            alignItems: 'center',

          }}
        >
           <RenderVehicle key={item.id} vehicle={item} />
        </Box>
      ))}
    </Box>
    </div>
  );

};

export default ItemList;
